import SectionHeader from "../SectionHeader";
import Reveal from "../Reveal";
import { FORMATS, slug } from "../../data/site";
import { usePlayer } from "@/contexts/PlayerContext";

export const FormatsCloud = () => {
  const { openQuote } = usePlayer();
  return (
    <section id="formats" data-testid="formats-section" className="bg-black section-pad scroll-mt-16">
      <div className="container-x">
        <SectionHeader
          eyebrow="What we edit"
          eyebrowTestId="formats-eyebrow"
          title="You name it."
          support="If it isn't on this list, ask anyway. It probably is."
        />
        <Reveal className="max-w-4xl mx-auto">
          <div className="flex flex-wrap justify-center gap-2 md:gap-2.5" data-testid="formats-cloud">
            {FORMATS.map((f) => (
              <span
                key={f}
                data-testid={`format-pill-${slug(f)}`}
                className="rounded-full border border-white/15 px-4 py-2 text-xs md:text-sm font-heading font-medium text-white/70 hover:border-[#C8F031] hover:text-[#C8F031] transition-colors duration-200 cursor-default"
              >
                {f}
              </span>
            ))}
          </div>
          <div className="mt-12 text-center">
            <button
              data-testid="formats-tell-us-btn"
              onClick={openQuote}
              className="font-heading text-sm font-bold text-[#C8F031] hover:text-white transition-colors min-h-[44px]"
            >
              Don't see yours? Tell us →
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FormatsCloud;
